import type {
  EnvironmentId,
  PullRequestActivity,
  PullRequestDetail,
  PullRequestRef,
} from "@cmmd-forge/contracts";

import { cmmdApiClient } from "~/environments/cmmdApi";
import { commandPullRequestRef } from "~/lib/pullRequestReactQuery";
import { PullRequestReactionPills } from "../timeline/PullRequestReactionPills";
import { usePullRequestSerializedCommand } from "../timeline/usePullRequestSerializedCommand";

export function PullRequestDescriptionReactions(props: {
  readonly activity: PullRequestActivity | undefined;
  readonly detail: PullRequestDetail;
  readonly environmentId: EnvironmentId;
  readonly reference: PullRequestRef;
  readonly isDetailFresh: boolean;
}) {
  const command = usePullRequestSerializedCommand(props.environmentId, props.reference);
  const canReact = props.detail.capabilities.reactions === true && props.isDetailFresh;
  const reactions = props.activity?.reactions;
  return canReact || (reactions?.length ?? 0) > 0 ? (
    <PullRequestReactionPills
      reactions={reactions}
      enabled={canReact}
      pending={command.isPending}
      onToggle={(content, reacted) =>
        command.mutate(async () => {
          await cmmdApiClient.setPullRequestReaction({
            ...commandPullRequestRef(props.reference),
            idempotencyKey: crypto.randomUUID(),
            content,
            reacted,
          });
        })
      }
    />
  ) : null;
}
